import {Component, OnInit} from '@angular/core';
import {BaseDashComponent} from 'src/cad/dashboard/views/content/components/base-dash.component';
import {ApiHelper} from 'cad/common/services/api/api-helper';
import {RouterService} from 'cad/core/services/router/router.service';
import {ActivatedRoute} from '@angular/router';
import {UserPreferenceService} from 'cad/common/services/preferences/user-preferences';
import {Observable, of} from 'rxjs';
import {UiGridApi} from 'src/ag-grid-wrapper';
import {GridReadyEvent, RowClickedEvent} from '@ag-grid-community/core';
import {UserModelService} from 'cad/common/services/user/user-model-service';
import {
  NominationConfirmationPinnedLocationApi
} from 'cad/common/services/api/nomination/confirmation/pinned-location/pinned-location';
import {
  NominationConfirmationMaintenancePinnedLocationApi
} from 'cad/common/services/api/nomination/confirmation-maintenance/pinned-location/pinned-location';
import {AssetGroup} from 'common/types/cad.constants';
import {LayoutService} from 'common/services/layout/layout';
import {map} from 'rxjs/operators';

const GRID_LAYOUT = {
  defaults: {
    entityType: false,
    entityId: false,
    entityName: false,
    recipientName: true,
    pointCd: true,
    locationName: true,
  },

  pipelines: {
    FGT: {
      entityType: true,
      entityId: true,
      entityName: true,
      recipientName: true,
      pointCd: false,
      locationName: false,
    }
  }
};

@Component({
  selector: 'confirmation-dashboard',
  templateUrl: './confirmation-dashboard.component.html',
})
export class ConfirmationDashboardComponent extends BaseDashComponent implements OnInit {
  public name: string = 'conf';
  private gridApi: UiGridApi;
  public itemLayout$: Observable<any>;
  private defaultNavigation: string = '/nominations/confirmations/confirmation';
  private confirmationMaintenanceNavigation: string = '/nominations/confirmations/confirmation-maintenance';

  constructor(public apiHelper: ApiHelper,
              public routerService: RouterService,
              public activatedRoute: ActivatedRoute,
              public userPreferenceService: UserPreferenceService,
              public confirmationPinnedLocationApi: NominationConfirmationPinnedLocationApi,
              public confirmationMaintenancePinnedLocationApi:NominationConfirmationMaintenancePinnedLocationApi,
              private userModelService: UserModelService,
              private layoutService: LayoutService,
              ) {
    super(apiHelper, routerService, activatedRoute, userPreferenceService);
    this.itemLayout$ = this.layoutService.layoutStream(GRID_LAYOUT);
  }


  ngOnInit(): void {
    if (this.userDetails?.userId) {
      this.trimSize = 5;
      this.showLatest = true;
      this.itemData$ = this.getFilteredData(this.userModelService.getCurrentAssetGroup())
        .pipe(
          map((data) => this.trimData(data))
        );
    } else {
      this.itemData$ = of(null);
    }
    super.ngOnInit();
  }

  private getFilteredData(currentAssetGroup:string): Observable<any> {
    return currentAssetGroup === AssetGroup.FG
      ? this.confirmationMaintenancePinnedLocationApi.filter()
      : this.confirmationPinnedLocationApi.filter();
  }

  public getEmptyHeadline(): string {
    return 'No Pinned Confirmations';
  }
  public getDefaultHeadline(): string {
    return 'Pinned Confirmations';
  }
  public getName(): string {
    return this.name;
  }

  public onGridReady($event: GridReadyEvent): void {
    this.gridApi = $event.api;
  }

  public onRowClicked($event: RowClickedEvent): void {
    const data = {
      assetNbr: this.userModelService.getCurrentAssetNbr(),
      pointCd: $event.data.pointCd,
      beginDate: dateUtil().getFormattedDate(dateUtil().getCurrentDateTime(), 'YYYY-MM-DD'),
      endDate: dateUtil().getFormattedDate(dateUtil().getCurrentDateTime(), 'YYYY-MM-DD'),
      type: $event.data.tabName
    };
    const navigation = this.userModelService.getCurrentAssetGroup() === AssetGroup.FG
      ? this.confirmationMaintenanceNavigation+`/${$event.data.entityId}`
      : this.defaultNavigation+`/${$event.data.pointCd}`;
    this.routerService.navigateWithData({...$event.data, data}, [ `${navigation}` ]);
  }
}
